import React from 'react';
import s from './DisconnectModal.module.css';
import Modal from '../../../../shared/ui/modal/Modal';
import Button from '../../../../shared/ui/button/Button';
import Spinner from '../../../../shared/ui/spinner/Spinner';

interface DisconnectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    provider: string;
    isLoading: boolean;
}

const DisconnectModal: React.FC<DisconnectModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    provider,
    isLoading,
}) => {
    if (!isOpen) return null;

    const getProviderName = (provider: string) => {
        const names: { [key: string]: string } = {
            facebook: 'Facebook',
            instagram: 'Instagram',
            linkedin: 'LinkedIn',
            pinterest: 'Pinterest',
            threads: 'Threads',
            tiktok: 'TikTok',
            twitter: 'Twitter',
            youtube: 'YouTube',
        };
        return names[provider] || provider;
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} width="400px">
            {isLoading ? (
                <div className={s.modal}>
                    <h3 className={s.title}>Disconnecting...</h3>
                    <Spinner />
                </div>
            ) : (
                <div className={s.modal} onClick={(e) => e.stopPropagation()}>
                    <h3 className={s.title}>
                        Are you sure you want to disconnect {getProviderName(provider)}?
                    </h3>
                    <p className={s.subtitle}>
                        This action will disconnect your {getProviderName(provider)} from the
                        SimpleCreate.
                    </p>
                    <div className={s.buttons}>
                        <Button onClick={onClose} text="Cancel" />

                        <Button
                            onClick={onConfirm}
                            text="Disconnect"
                            style={{ backgroundColor: '#ff4444', color: '#fff' }}
                        />
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default DisconnectModal;
